import { useBreadcrumbStore } from './store'

export { useBreadcrumbStore }
export type { BreadcrumbItem } from './types'

export function useDatalibraryBreadcrumb() {
  return useBreadcrumbStore()
}
